module.exports = __webpack_public_path__ + "static/media/v_logo-pa.e89c200c.svg";